import {
  Button, Loading, Table, Alert,
} from '@roo/roo';
import React, { useState } from 'react';
import { getAssignedProjects } from '@assets/apis/review';
import Header from '@components/HeaderWithoutMenu';
import './index.scss';
import { useHistory } from 'react-router-dom';
import { Column } from '@roo/roo/Table';
import VoteModal from '@components/Review/VoteModal';
import { getGroupStatus, GroupStatus } from '@components/GroupStatus';
import { ReviewTemplateType } from '@components/Review/reviewTypes';
import { emptyImg } from '@assets/images/empty.png';
// babel-plugin-transform-typescript不支持const enmus
// https://babeljs.io/docs/en/babel-plugin-transform-typescript#caveats
// 可以考虑引入 babel-plugin-const-enum， 这个项目就先这样吧
enum VoteStatus {
  DISABLED = 0,
  AVAILABLE,
  DONE,
}

const noticeText = `1.组别状态为“待确认”时，为预分配状态，您可点击项目编号查看项目详情，但无法操作评审。
2.若您发现为您分配的某组的项目中存在学科不匹配、利益相关、领域不相关等需要退评的情况，请及时联系huanbao@meituan.com申请退评，我们将尽快为您分配新的评审组别与项目。
3.所有的项目全部提交评审结论之后会自动出现投票弹框，您需要为项目分配票额。
`;

const Empty = function () {
  return (
    <div className="review-empty">
      <img src={emptyImg} alt="空图片" />
      <p className="info-1">暂无待评审项目</p>
      <p className="info-2">您尚未被分配可评审的项目，若有问题请联系 huanbao@meituan.com</p>
    </div>
  );
};

const ReviewHead = ({ groupName, groupStatus }) => (
  <p className="review-list__group__head">
    {groupName}
    （
    {getGroupStatus(groupStatus)}
    ）
  </p>
);

const ReviewFoot = ({
  groupId, voteStatus, action, groupName, projects,
}) => {
  const voteAvailable = voteStatus === VoteStatus.AVAILABLE;
  const voteDone = voteStatus === VoteStatus.DONE;
  const voteNotStart = voteStatus === VoteStatus.DISABLED;
  const [modelVisible, setVisible] = useState(false);
  const projectType = projects.find((p) => !!p.projectNo)?.projectType;

  return (
    !voteNotStart && (
      <div className="review-list__group__foot">
        {voteAvailable && '您已完成组内项目的评审结论提交，请投票。'}
        <Button onClick={() => setVisible(!modelVisible)}>
          {voteDone ? '查看票型' : '去投票'}
        </Button>

        <VoteModal
          projectType={projectType}
          groupId={groupId}
          groupName={groupName}
          voteAvailable={voteAvailable}
          visible={modelVisible}
          onVisibleChange={setVisible}
          reloadList={action}
        />
      </div>
    )
  );
};

const ReviewTable = ({ projects, groupStatus, reviewTemplateType }) => {
  const disabled = groupStatus === GroupStatus.UN_DETERMINED;
  const projectType = projects.find((p) => !!p.projectNo)?.projectType;
  const isMatrixReview = reviewTemplateType === ReviewTemplateType.MATRIX;

  const history = useHistory();
  const sciColumns: Column<any>[] = [
    {
      prop: 'scientistName', label: '申报人姓名', align: 'center', width: '12%',
    },
  ];
  const innoColumns: Column<any>[] = [
    {
      prop: 'organizationName', label: '项目机构名称', align: 'center', width: '12%',
    },
    {
      prop: 'reportDirectionName', label: '申报方向', align: 'center', width: '10%',
    },
  ];
  const matrixColumns: Column<any>[] = [
    {
      prop: 'score',
      label: '分值',
      align: 'center',
      width: '10%',
      render: (_, item) => {
        if (disabled) {
          return <>-</>;
        }

        return <>{item.score ?? '-'}</>;
      },
    },
  ];
  const columns: Column<any>[] = [
    {
      prop: 'projectNo',
      label: '项目',
      align: 'center',
      width: 200,
      render: (text, item) => {
        const { id, projectNo, projectType } = item;
        return (
          <Button
            type="brand-text"
            style={{ color: '#FF6A00' }}
            onClick={() => {
              history.push(`/review/info/${projectNo}?projectType=${projectType}&reviewId=${id}`);
            }}
          >
            《
            {text}
            》
          </Button>
        );
      },
    },
    {
      prop: 'projectTypeName', label: '项目类型', align: 'center', width: 380,
    },
    ...(projectType === 1 ? sciColumns : []),
    ...(projectType === 2 ? innoColumns : []),
    {
      prop: 'projectStageName', label: '阶段', align: 'center', width: '10%',
    },
    {
      prop: 'judgeStatusName',
      align: 'center',
      label: '评审状态',
      width: '10%',
      render(text, item) {
        return disabled ? (
          <>-</>
        ) : (
          <span className={`status status-${item.judgeStatus}`}>{text}</span>
        );
      },
    },
    ...(isMatrixReview ? [] : matrixColumns),
    {
      prop: 'date',
      align: 'center',
      label: '操作',
      render: (_, item) => {
        const {
          id, projectNo, judgeStatus, projectType,
        } = item;
        if (disabled) {
          return <>-</>;
        }
        let bt = '';
        if (judgeStatus === 0 || judgeStatus === 1) {
          bt = '进入评审';
        } else {
          bt = '查看评审详情';
        }
        return (
          <Button
            type="brand-text"
            style={{ color: '#FF6A00' }}
            onClick={() => {
              history.push(`/review/detail/${projectNo}?projectType=${projectType}&reviewId=${id}`);
            }}
          >
            {bt}
          </Button>
        );
      },
    },
  ];
  return (
    <Table
      className="review-list__group__content"
      // showIndex
      border
      rowKey="projectNo"
      columns={columns}
      data={projects}
    />
  );
};

const ReviewList = function ({ data, action }) {
  return (
    <div className="review-list">
      <p className="title"> 参与评审项目列表</p>
      {data.total && (
        <Alert
          className="review-list__alert"
          type="warning"
          icon="roo-icon-exclamation-circle"
          title={noticeText}
        />
      )}
      {data.groups.map((group) => (
        <div key={group.groupId} className="review-list__group">
          <ReviewHead groupName={group.groupName} groupStatus={group.groupStatus} />
          <ReviewTable
            projects={group.projects}
            groupStatus={group.groupStatus}
            reviewTemplateType={group.reviewTemplateType}
          />
          <ReviewFoot {...group} action={action} />
        </div>
      ))}
    </div>
  );
};

class List extends React.Component {
  constructor(props) {
    super(props);
    this.getProject();
  }

  state = {
    review: null,
    loading: true,
  };

  getProject = async () => {
    const res = await getAssignedProjects();
    if (res?.projects) {
      res.projects = (res?.projects || []).map((t, idx) => ({
        ...t,
        idx: idx + 1,
        projectStageName: (t.projectStageName || '').replace('阶段', ''),
      }));
    }

    this.setState({ review: res, loading: false });
  };

  render() {
    const { review, loading } = this.state;
    return (
      <div>
        <Header plate="评审平台" />
        <div className="page-list" style={{ marginTop: 0 }}>
          <div className="warp">
            {review
              && (review.total === 0 ? (
                <Empty />
              ) : loading ? (
                <Loading visible backdrop fullscreen />
              ) : (
                <ReviewList data={review} action={this.getProject} />
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default List;
